<script lang="ts">
    import cn from 'classnames';

    import { Shape, Size, BorderColor } from '../../types';

    import s from './shape-container.module.css';

    export let shape: Shape = Shape.rounded;
    export let size: Size = Size.medium;
    export let borderColor: NullableType<BorderColor> = undefined;
    export let isRetired: boolean = false;
    export let classes: string = '';
</script>

{#if shape === Shape.hexagon}
    <div class={cn(s.root, s.hexagon, s[size], borderColor && s[borderColor], isRetired && s.retired, classes)}>
        <div class={cn(s.inner, s.hexagon, { [s.retired]: isRetired })}>
            <div class={cn(s.inner, s.hexagon)}>
                <slot />
            </div>
        </div>
    </div>
{:else}
    <div class={cn(s.shape, s[shape], s[size], borderColor && s[borderColor], classes)}>
        <slot />
    </div>
{/if}
